import React, { useState } from 'react';
import {
	Dialog,
	DialogContent,
	makeStyles,
	Box,
	useTheme,
	useMediaQuery,
	Divider,
	Grid,
	TableContainer,
	Table,
	TableHead,
	TableBody,
	TableRow,
	TableCell,
	withStyles,
} from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import BodyText from './BodyText';
import TitleText from './TitleText';
import SuccessModal from './SuccessModal';
import { toggleFlightDetailModal } from '../../reducers/UiReducer';
import {
	agentloginDispatch,
	agentlogoDispatch,
} from '../../reducers/UserReducer';
import ErrorModal from './ErrorModal';
import PassengerDetailRow from './PassengerDetailRow';
import FlightSegment from './FlightSegment';
const tableHeaders = [
	'Type',
	'Passenger Name',
	'Date of Birth',
	'Passport No',
	'Ticket No',
];
const tableHeaders2 = [
	'AirLine Name',
	'Flight No',
	'Origin',
	'Destination',
	'Depart Date & Time',
	'Arrival Date & Time',
];

const StyledTableCell = withStyles((theme) => ({
	head: {
		// fontWeight: 600,

		// padding: 3,
		fontSize: 12,
		textTransform: 'uppercase',
	},
	root: {
		borderBottom: 'none',
		paddingBottom: 0,
	},
}))(TableCell);
const useStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: 'transparent',
		backdropFilter: 'blur(2px)',
	},
	closeButton: {
		position: 'absolute',
		right: theme.spacing(1),
		top: theme.spacing(3),
		[theme.breakpoints.down('xs')]: {
			top: theme.spacing(2.5),
		},
		color: theme.palette.grey[500],
	},
	nextButton: {
		backgroundColor: '#E61855',
		color: 'white',
		borderColor: '#E61855',
		borderRadius: 15,
		fontWeight: 600,
		width: '100%',
		padding: 10,
		'&:hover': {
			backgroundColor: '#E61855',
		},
	},
}));

const FlightModalDetail = ({ title }) => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const { flightdetail } = useSelector((state) => state.ui);
	const [upload, setUpload] = useState(null);
	const [user, setUser] = useState({
		filename: '',
	});
	const { filename } = user;
	const onInputChange = (e) => {
		// setUser({ ...user, [e.target.name]: e.target.value });
		const fileToUpload = e.target.files;
		// setUser({ ...user, [e.target.name]: fileToUpload[0] });
		// console.log(e.target);
		setUpload(fileToUpload[0]);
	};
	const handleClose = () => {
		dispatch(toggleFlightDetailModal(false));
		// dispatch(setSuccessMessage(''));
	};
	const onSubmit = async (e) => {
		e.preventDefault();
		// var dat = user;
		// var formData = JSON.stringify(dat);
		// console.log(formData);
		// let formData2 = {
		// 	agent_id: 1,
		// 	agentLogo: dat,
		// };
		// console.log(e);
		let formUpdate = new FormData();
		formUpdate.append('agent_id', 1);
		formUpdate.append('agentLogo', upload);
		dispatch(agentlogoDispatch(formUpdate));
	};
	const theme = useTheme();
	const fileInputRef = React.createRef();
	const matches = useMediaQuery(theme.breakpoints.down('xs'));

	return (
		<Dialog
			PaperProps={{
				style: {
					borderRadius: 20,
					maxWidth: 1020,
				},
			}}
			TransitionProps={{
				style: { backgroundColor: 'transparent' },
			}}
			onClose={handleClose}
			aria-labelledby='customized-dialog-title'
			className={classes.root}
			open={flightdetail}
			fullWidth={true}
			maxWidth={'xs'}>
			<DialogContent
				style={{
					paddingBottom: 20,
				}}>
				<h3
					three={matches ? false : true}
					style={{ fontWeight: 600, textAlign: 'center' }}>
					Flight Details
				</h3>
				<Grid container spacing={2}>
					<Grid item xs={4}>
						<h6>Order Id</h6>
						<h6>BIZTKT125166</h6>
					</Grid>
					<Grid item xs={4}>
						<h6>PNR</h6>
						<h6>XDS3PB</h6>
					</Grid>
					<Grid item xs={4}>
						<h6>Booking Status</h6>
						<h6>BOOKED</h6>
					</Grid>
				</Grid>
				<Grid container spacing={2}>
					<Grid item xs={4}>
						<h6>Booking Id</h6>
						<h6>42762835</h6>
					</Grid>
					<Grid item xs={4}>
						<h6>Fare Type</h6>
						<h6>XDS3PB</h6>
					</Grid>
					<Grid item xs={4}>
						<h6>Ticket Cost</h6>
						<h6>INR 4197.00</h6>
					</Grid>
				</Grid>
				<Grid container spacing={2}>
					<Grid item xs={4}>
						<h6>Flight Depart From</h6>
						<h6>Hyderabad, India</h6>
					</Grid>
					<Grid item xs={4}>
						<h6>Booking Date</h6>
						<h6>04/09/2020</h6>
					</Grid>
					<Grid item xs={4}>
						<h6>Payable Amount</h6>
						<h6>INR 4197.00</h6>
					</Grid>
				</Grid>
				<Grid container spacing={2}>
					<Grid item xs={4}>
						<h6>Flight Land To</h6>
						<h6>Ranchi, India</h6>
					</Grid>
					<Grid item xs={4}>
						<h6>Journey Date</h6>
						<h6>11/10/2020</h6>
					</Grid>
					<Grid item xs={4}>
						<h6>Payment Mode</h6>
						<h6>OFFLINE</h6>
					</Grid>
				</Grid>
				<Divider />
				<h4>Passenger Details</h4>
				<TableContainer style={{ marginTop: 15 }}>
					<Table>
						<TableHead>
							<TableRow>
								{tableHeaders.map((title, index) => (
									<StyledTableCell key={title}>{title}</StyledTableCell>
								))}
							</TableRow>
						</TableHead>
						<TableBody>
							<PassengerDetailRow />
						</TableBody>
					</Table>
				</TableContainer>
				<h4>Flight Segments</h4>
				<TableContainer style={{ marginTop: 15 }}>
					<Table>
						<TableHead>
							<TableRow>
								{tableHeaders2.map((title, index) => (
									<StyledTableCell key={title}>{title}</StyledTableCell>
								))}
							</TableRow>
						</TableHead>
						<FlightSegment />
					</Table>
				</TableContainer>
				<Grid container style={{ justifyContent: 'center' }}>
					<Box
						textAlign='center'
						style={{ cursor: 'pointer' }}
						mt={2}
						onClick={() => dispatch(toggleFlightDetailModal(false))}>
						<BodyText textStyle={{ color: '#E61855', fontWeight: 600 }}>
							Close
							<Divider style={{ backgroundColor: '#E61855' }} />
						</BodyText>
					</Box>
				</Grid>
				<SuccessModal />
				<ErrorModal />
			</DialogContent>
		</Dialog>
	);
};

export default FlightModalDetail;
